var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap vgm_pop vgm_area",
      staticStyle: { width: "950px", "max-height": "600px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.CSBL200.328"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content_box" }, [
          _c("table", { staticClass: "tbl_col" }, [
            _vm._m(0),
            _vm._m(1),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.masterCntrNo,
                          expression: "masterCntrNo",
                        },
                      ],
                      staticClass: "wid200",
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.masterCntrNo = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function ($event) {
                            return _vm.changeMasterCntrNo($event)
                          },
                        ],
                      },
                    },
                    _vm._l(_vm.masterCntrList, function (vo, idx) {
                      return _c(
                        "option",
                        {
                          key: "cntrNo_" + idx,
                          domProps: { value: vo.cntrNo },
                        },
                        [_vm._v(_vm._s(vo.cntrNm))]
                      )
                    }),
                    0
                  ),
                ]),
                _c("td", [_c("p", [_vm._v(_vm._s(_vm.masterWgt))])]),
                _c("td", [_c("p", [_vm._v(_vm._s(_vm.masterCbm))])]),
                _c("td", [_c("p", [_vm._v(_vm._s(_vm.masterPkg))])]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "content_box" }, [
          _c("table", { staticClass: "tbl_col" }, [
            _vm._m(2),
            _c("tbody", [
              _vm._m(3),
              _c("tr", [
                _c("td", { staticClass: "border_left" }, [
                  _vm._v(_vm._s(_vm.houseTotWgt)),
                ]),
                _c("td", [_vm._v(_vm._s(_vm.houseTotCbm))]),
                _c("td", [_vm._v(_vm._s(_vm.houseTotPkg))]),
              ]),
            ]),
          ]),
          _c("table", { staticClass: "tbl_col mt20" }, [
            _vm._m(4),
            _vm._m(5),
            _c(
              "tbody",
              _vm._l(
                _vm.selectHouseCntrList,
                function (selectHouseCntrVo, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_c("p", [_vm._v(_vm._s(index + 1))])]),
                    _c("td", [
                      _c("p", [_vm._v(_vm._s(selectHouseCntrVo.fwdrBlNo))]),
                    ]),
                    _c("td", [_c("p", [_vm._v(_vm._s(selectHouseCntrVo.wt))])]),
                    _c("td", [
                      _c("p", [_vm._v(_vm._s(selectHouseCntrVo.grsCbm))]),
                    ]),
                    _c("td", [
                      _c("p", [_vm._v(_vm._s(selectHouseCntrVo.pkgQty))]),
                    ]),
                  ])
                }
              ),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ONEX010P100.036")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "31%" } }),
      _c("col", { attrs: { width: "23%" } }),
      _c("col", { attrs: { width: "23%" } }),
      _c("col", { attrs: { width: "23%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Master Container No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Weight (kgs)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Measure")]),
        _vm._v(" "),
        _c("th", [_vm._v("Package")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "31%" } }),
      _c("col", { attrs: { width: "23%" } }),
      _c("col", { attrs: { width: "23%" } }),
      _c("col", { attrs: { width: "23%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("th", { attrs: { rowspan: "2" } }, [_vm._v("House B/L Total")]),
      _vm._v(" "),
      _c("th", [_vm._v("Weight (kgs)")]),
      _vm._v(" "),
      _c("th", [_vm._v("Measure")]),
      _vm._v(" "),
      _c("th", [_vm._v("Package")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "10%" } }),
      _c("col", { attrs: { width: "25%" } }),
      _c("col", { attrs: { width: "25%" } }),
      _c("col", { attrs: { width: "25%" } }),
      _c("col", { attrs: { width: "25%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("House B/L No.")]),
        _vm._v(" "),
        _c("th", [_vm._v("Weight (kgs)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Measure")]),
        _vm._v(" "),
        _c("th", [_vm._v("Package")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }